import config from '@/config'
import HttpClient from '@/api/http/client'
import store from 'store'
import ResponseError from '@/api/http/ResponseError'
import windowStore from '@/store/modules/window.store'

const http = new HttpClient(config.sabBaseUrl)

export default {
  async getCountryCode() {
    const country = store.get('country')
    if (country) {
      return country
    }

    try {
      const response = await http.get(`/api/v1/utils/country`).then(res => res.json())
      store.set('country', response.country)
      return response.country
    } catch {
      return 'US'
    }
  },
  async signIn(credentials) {
    const response = await http.post('/api/v1/sessions/login', credentials, true)

    if (response.ok) {
      const data = await response.json()
      http.setTokens(data.access_token, data.refresh_token)
      return
    }

    throw new ResponseError(response.status)
  },
  async signUp(credentials, extraInfo, authenticationPlatform, recaptchaToken, privacyPreferences) {
    extraInfo.emailLanguage = windowStore.state.language

    const response = await http.post('/api/v1/user', {
      email: credentials.email,
      password: credentials.password
    }, true)

    if (response.ok) {
      return
    }

    throw new ResponseError(response.status)
  },
  async subscriptionsStatus() {
    return http.get('/api/v1/subscriptions/status', true).then(data => data.json())
  },
  async signOut() {
    const response = await http.delete('/api/v1/sessions/logout', true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async refreshToken() {
    const refreshToken = localStorage.getItem('refreshToken')
    const response = await http.post('/api/v1/sessions/refresh', {
      refresh_token: refreshToken
    }, true)
    if (response.ok) {
      const data = await response.json()
      http.setTokens(data.access_token, data.refresh_token)
      return
    }
    throw new ResponseError(response.status)
  },
  async getUser() {
    return http.get('/api/v1/user', true).then(data => data.json())
  },
  async verifyProfile() {
    return http.get('/api/v1/user/profiles', true).then(data => data.json())
  },
  async createChildProfile(childProfile) {
    const response = await http.post('/api/v1/user/profiles', childProfile, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async updateChildProfile(id, childProfile) {
    const response = await http.put(`/api/v1/user/profiles/${id}`, childProfile, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async removeChildProfile(id) {
    const response = await http.delete(`/api/v1/user/profiles/${id}`, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async getAllChildrenProfiles() {
    return http.get('/api/v1/user/profiles', true)
  },
  async changeEmail(email) {
    const response = await http.patch('/api/v1/user/change_email', { email }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async changePassword(currentPassword, password) {
    const response = await http.patch('/api/v1/user/change_password', { current_password: currentPassword, password }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async createVindiUser(email, skuId, card, billing) {
    const response = await http.post(`/api/v1/subscriptions/vindi/create_user`, {
      name: card.holderName,
      email: email,
      registry_code: billing.cpf,
      address: {
        street: billing.address,
        number: billing.number,
        additional_details: billing.additionalDetails,
        zipcode: billing.zipcode,
        neighborhood: billing.district,
        city: billing.city,
        state: billing.state,
        country: JSON.parse(localStorage.getItem('country'))
      }
    }, true)

    let body = null
    try { body = await response.json() } catch {}

    if (!response.ok) {
      return false
    }

    return body
  },
  async subscribeVindiUser(gatewayToken, vindiPlanId) {
    const response = await http.post(`/api/v1/subscriptions/vindi/subscribe`, {
      gateway_token: gatewayToken,
      vindi_plan_id: vindiPlanId
    }, true)

    let body = null
    try { body = await response.json() } catch {}

    if (!response.ok) {
      return false
    }

    return body
  },
  async cancelSubscription(subscriptionId) {
    const response = await http.post(`/api/v1/subscriptions/manage/${subscriptionId}/cancel`)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  }
}
